module.exports = __webpack_public_path__ + "static/img/3.5bcbb69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/3.png
// module id = xie9
// module chunks = 1